
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import Contact from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
